import * as Yup from "yup";

const validate = Yup.object().shape({
  selectedGroupId: Yup.number().nullable(true).required("Выберите группу"),
});

export default validate;
